import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';

function TotalPetsChart() {
  const { dashboardData } = useSelector((state) => state.dashboard);

  if (!dashboardData) return null;

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const lastYearData = months.map(month => dashboardData.lastYears?.[month] || 0);
  const currentYearData = months.map(month => dashboardData.currentYears?.[month] || 0);

  const chartOptions = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: { show: false }
    },
    colors: ['#2E93fA', '#66DA26'],
    stroke: {
      width: [3, 3],
      curve: 'smooth',
      dashArray: [0, 5] // solid for this year, dotted for last year
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      markers: { fillColors: ['#2E93fA', '#66DA26'] }
    },
    xaxis: {
      categories: months
    },
    yaxis: {
      labels: {
        formatter: val => `${val}`
      }
    },
    fill: {
      gradient: {
        type: "vertical",
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.3,
        opacityTo: 0,
        stops: [0, 90, 100]
      }
    },
    tooltip: {
      y: {
        formatter: val => `${val} pets`
      }
    },
    grid: {
      borderColor: '#f1f1f1',
    }
  };

  const chartSeries = [
    {
      name: 'This Year',
      data: currentYearData
    },
    {
      name: 'Last Year',
      data: lastYearData
    }
  ];

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '12px',
        padding: '20px',
        boxShadow: '0 0 10px rgba(0,0,0,0.05)'
      }}
    >
      <h3 style={{ marginBottom: '10px' }}>Total Pets</h3>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
}

export default TotalPetsChart;